export const queryKeys = {
    user: () => ['user'] as const,
    companies: (orgId: string) => ['companies', orgId] as const,
    contacts: () => ['contacts'] as const,
    addressBook: () => ['address-book'] as const,
    companyContacts: (companyId: string) => ['company-contacts', companyId] as const,
    deals: (orgId: string) => ['deals', orgId] as const,
    projects: (orgId: string) => ['projects', orgId] as const,
    recentlyOpenedProjects: (userId: string, limit: number) => ['recently-opened-projects', userId, limit] as const,
    conversationQueue: () => ['conversations-queue'] as const,
    calendar: () => ['calendar'] as const,
    organization: (orgId: string) => ['organization', orgId] as const,
    teamInvites: (orgId: string) => ['team-invites', orgId] as const,
}
